<template>
  <el-menu
    :default-active="activeIndex"
    :class="className"
    unique-opened
    :background-color="backgroundColor"
    :text-color="textColor"
    :active-text-color="activeTextColor">
    <template v-for="item in dataList">
      <template v-if="item.children && item.children.length > 0">
        <el-submenu :index="item.name" :popper-class="className">
          <template slot="title">
            <span v-if="item.img" class="sidebar-img">
              <img :src="item.img">
            </span>
            <i v-else :class="`dgd-icon-${item.icon}`"></i>
            <span>{{ item.name }}</span>
          </template>
          <el-menu-item-group v-if="item.children">
            <el-menu-item v-for="(childItem, childIndex) in item.children"
                          :key="childIndex"
                          @click="jumpUrl(childItem.path || childItem.action)"
                          :index="childItem.name + childItem.path">
              {{ childItem.name }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </template>
      <template v-else>
        <el-menu-item :index="item.name + item.path"
                      @click="jumpUrl(item.path || item.action)">
          <i :class="`dgd-icon-${item.icon}`"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </template>
    </template>
  </el-menu>

  <!--  <gd-menu :default-active="activeIndex" unique-opened @select="handleItemClick" v-if="false">-->
  <!--    <gd-nav-menu :routes="dataList"></gd-nav-menu>-->
  <!--    &lt;!&ndash;<SidebarItem :routes="dataList"></SidebarItem>&ndash;&gt;-->
  <!--  </gd-menu>-->
</template>

<script>
  import { deepDeal, typeOf } from '../../core/utils/helper';

  export default {
    name: 'global-sidebar',
    components: {},
    data () {
      return {
        activeIndex: this.defaultActive,
      };
    },
    props: {
      theme: {
        type: String,
        default: 'black',
      },
      backgroundColor: {
        type: String,
        default: '#283748',
      },
      textColor: {
        type: String,
        default: '#fff',
      },
      activeTextColor: {
        type: String,
        default: '#00A4FF',
      },
      dataList: {
        type: Array,
      },
      defaultActive: {
        type: String,
        default: '',
      },
    },
    computed: {
      className () {
        return this.theme === 'black' ? 'dgd-menu--dark' : '';
      },
    },
    mounted () {
      this.handleActiveIndex();
    },
    watch: {
      dataList (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.handleActiveIndex();
        }
      },
      '$route': 'handleActiveIndex',
    },
    methods: {
      handleActiveIndex () {
        deepDeal(this.dataList, (key, value, parent) => {
          if (key === 'path' &&
            (this.isSameUrl(value, this.$route.path) || this.isSameUrl(value, this.$route.fullPath))) {
            this.activeIndex = parent.name + parent.path;
          }
        });
      },
      isSameUrl (a, b) {
        return decodeURIComponent(a) === decodeURIComponent(b);
      },
      handleItemClick (index, indexPath, item) {
        this.$emit('select', index, indexPath, item);
      },
      jumpUrl (url) {
        if (typeOf(url) === 'function') {
          url();
        }
        else {
          this.$router.push(url);
        }
      },
    },
  };
</script>

<style lang="less">
  .sidebar-img {
    width: 26px;
    height: 26px;
    display: inline-block;
    margin-right: 14px;

    img {
      max-width: 100%;
      max-height: 100%;
      vertical-align: top;
    }
  }
</style>
